import { render, staticRenderFns } from "./UserColumn.vue?vue&type=template&id=83200454&"
import script from "./UserColumn.vue?vue&type=script&lang=js&"
export * from "./UserColumn.vue?vue&type=script&lang=js&"
import style0 from "./UserColumn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports